import React from 'react';

export default function FormattedNumber({ value, currency = 'USD' }) {
    return <span>{new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(value)}</span>;
}
